import styled from "styled-components"

export const Component = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 10px;
`

export const Trigger = styled.button<{ $hasSelection?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid
    ${({ $hasSelection, theme }) => ($hasSelection ? theme.colors.blue.main : "#ccc")};
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 16px;
  color: ${({ $hasSelection, theme }) =>
    $hasSelection ? theme.colors.black.secondary : "#6b7280"};
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black.secondary};
  background: none;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.blue.main};
  }
`

export const EmptyMessage = styled.span`
  padding: 10px 4px;
  font-size: 14px;
  color: #6b7280;
`

export const ShowMoreButton = styled.button`
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.blue.main};
  background: none;
  color: ${({ theme }) => theme.colors.blue.main};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: rgba(0, 97, 230, 0.06);
  }
`
